import React, { useEffect, useState } from "react";
import axios from "axios";

import styled from "styled-components";
import moment from "moment";
import { Expense } from "./components/Expense.component";
import { Spin } from "antd";
import { handleError } from "../../sagas";

import { SelectMonth } from "./components/SelectMonth.component";
import { Filter } from "./components/Filter.component";
import {
  fetchExpensesDisctinctClients,
  fetchExpensesDisctinctUsers,
  fetchExpensesDisctinctCompany
} from "../../api/api";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const Button = styled.div`
  width: 200px;
  background: #e66800;
  text-align: center;
  padding: 10px;
  padding-top: 200px;
  font-size: 25px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
  color: white;
`;
const baseapi = process.env.REACT_APP_API + "/api";
const PAGE_SIZE = 1;

const start_date = moment().startOf("month");

const end_date = moment().endOf("month");

const Accounting = ({ available, token, fetchExpenseRejectTypes, rejectTypes }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [rangeDate, setRangeDate] = useState([start_date, end_date]);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedClient, setSelectedClient] = useState();
  useEffect(() => {
    fetchExpenseRejectTypes();
  }, []);
  const rejectExpense = async data => {
    setIsLoading(true);
    try {
      await axios.post(`${baseapi}/expense/reject`, data, {
        headers: {
          Authorization: token
        }
      });
      await fetchExpenses();
    } catch (e) {
      handleError(e);
      console.log(e, e.response);
    }
    setIsLoading(false);
  };
  const validateExpense = async _id => {
    setIsLoading(true);
    await axios.post(
      `${baseapi}/expense/validate`,
      {
        _id
      },
      {
        headers: {
          Authorization: token
        }
      }
    );
    await fetchExpenses();
    setIsLoading(false);
  };
  const fetchExpenses = async () => {
    setIsLoading(true);
    const result = await axios.post(
      `${baseapi}/expenses`,
      {
        page: 1,
        match: {
          "status.id": 2,
          date: { $gte: { $date: rangeDate[0] }, $lte: { $date: rangeDate[1] } },
          "clients.label": selectedClient,
          user_email: selectedUser,
          user_company_label: selectedCompany
        },
        sort: { date: -1 },
        page,
        pageSize: PAGE_SIZE
      },
      {
        headers: {
          Authorization: token
        }
      }
    );

    setData(result.data.docs);
    setTotal(result.data.total);
    setTotalPages(result.data.totalPages);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchExpenses();
  }, [page, rangeDate, selectedClient, selectedUser, selectedCompany]);
  console.log(data[0]);
  const filters = {
    match: {
      "status.id": 2,
      date: { $gte: { $date: rangeDate[0] }, $lte: { $date: rangeDate[1] } },
      "clients.label": selectedClient,
      user_email: selectedUser,
      user_company_label: selectedCompany
    }
  };
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30, width: "30%" }}>{`Validation comptable`}</div>
          <div style={{ width: "30%" }}>
            <SelectMonth setRangeDate={setRangeDate} rangeDate={rangeDate} />
          </div>
          <div style={{ width: "30%", display: "flex", flexDirection: "column" }}>
            <Filter
              selectedItem={selectedClient}
              fetchDistinct={fetchExpensesDisctinctClients}
              placeholder={"dossier"}
              onChange={setSelectedClient}
              token={token}
              filters={filters}
            />
            <Filter
              selectedItem={selectedUser}
              fetchDistinct={fetchExpensesDisctinctUsers}
              placeholder={"utilisateur"}
              onChange={setSelectedUser}
              token={token}
              filters={filters}
            />
            <Filter
              selectedItem={selectedCompany}
              fetchDistinct={fetchExpensesDisctinctCompany}
              placeholder={"entreprise"}
              onChange={setSelectedCompany}
              token={token}
              filters={filters}
            />
          </div>
        </div>
        {total > 0 && <div style={{ fontSize: 20, margin: 20 }}>{`Il reste ${total} note(s) de frais à valider`}</div>}
      </HeaderContainer>
      {available ? (
        <div
          style={{
            height: "calc(100vh - 250px)",
            display: "flex"
          }}
        >
          <Button
            onClick={() => {
              setPage(p => (p === 1 ? p : p - 1));
            }}
          >
            Aller à la note de frais précédente
            <div style={{ marginTop: 10 }}> {page === 1 ? "(première page)" : `(vers la page ${page - 1})`}</div>
          </Button>
          <div style={{ display: "flex", flex: 1 }}>
            {isLoading ? (
              <Spin></Spin>
            ) : (
              <Expense expense={data[0]} validate={validateExpense} rejectTypes={rejectTypes} reject={rejectExpense} />
            )}
          </div>
          <Button
            onClick={() => {
              setPage(p => (p === totalPages ? p : p + 1));
            }}
          >
            Aller à la note de frais suivante
            <div style={{ marginTop: 10 }}>
              {page === totalPages ? "(dernière page)" : `(vers la page ${page + 1})`}
            </div>
          </Button>
        </div>
      ) : (
        <div style={{ fontSize: 60 }}>Ecran réservé à la comptable</div>
      )}
    </Container>
  );
};

export default Accounting;



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/Accounting/Accounting.js